import {observer, Popover2, React} from '@api'
import {useWhiteboardStore, WhiteboardMenuItem} from '@modules/whiteboard'
import {HamburgerMenuIcon} from '@radix-ui/react-icons'
import {icons} from '@stores'
import {PrimaryIconButton} from 'centric-ui-components'
import {MenuItem, Menu, MenuDivider} from '@blueprintjs/core'
import * as css from './WhiteboardHamburgerMenu.css'

export const WhiteboardHamburgerMenu = observer(function WhiteboardHamburgerMenu() {
  const {
    onClear, createUtil: {createRectangle},
    toggleBindingHandles, toggleRotateHandles, toggleCloneHandles, toggleShowSnaps, toggleDebugMode, toggleFocusMode, toggleShowGrid,
    settings: {ui: {isFocusMode, showGrid, isDebugMode, showRotateHandles, showCloneHandles, showBindingHandles, isSnapping}}
  } = useWhiteboardStore()
  return <Popover2
    className={css.root}
    interactionKind='hover'
    position='bottom-left'
    content={<Menu className={css.menu}>
      <MenuItem icon={'settings'} text={'Preferences'}>
        {DEBUG && <WhiteboardMenuItem shouldDismissPopover={false} icon={isDebugMode ? 'tick' : 'blank'} text='Debug Mode' onClick={toggleDebugMode}/>}
        <WhiteboardMenuItem shouldDismissPopover={false} icon={isFocusMode ? 'tick' : 'blank'} text='Focus Mode' onClick={toggleFocusMode} kbd='⇧.'/>

        <MenuDivider/>

        <WhiteboardMenuItem shouldDismissPopover={false} icon={isSnapping ? 'tick' : 'blank'} text='Show Snaps' onClick={toggleShowSnaps}/>
        <WhiteboardMenuItem shouldDismissPopover={false} icon={showRotateHandles ? 'tick' : 'blank'} text='Rotate Handles' onClick={toggleRotateHandles}/>
        <WhiteboardMenuItem shouldDismissPopover={false} icon={showBindingHandles ? 'tick' : 'blank'} text='Binding Handles' onClick={toggleBindingHandles}/>
        <WhiteboardMenuItem shouldDismissPopover={false} icon={showCloneHandles ? 'tick' : 'blank'} text='Clone Handles' onClick={toggleCloneHandles}/>
        <WhiteboardMenuItem shouldDismissPopover={false} icon={showGrid ? 'tick' : 'blank'} text='Grid' onClick={toggleShowGrid} kbd='#⇧G'/>
      </MenuItem>
      {/*<MenuItem icon={'plus'} text={'Add...'}>*/}
      {/*  <MenuItem icon={'square'} text={'Box'} onClick={createRectangle}/>*/}
      {/*  <MenuItem icon={'mugshot'} text={'Card'} onClick={createBuilderCard}/>*/}
      {/*</MenuItem>*/}
      <MenuItem icon={icons.clear} text={'Clear Canvas'} onClick={onClear}/>
    </Menu>}
  >
    <PrimaryIconButton icon={<HamburgerMenuIcon/>}/>
  </Popover2>
})



// WEBPACK FOOTER //
// ./src/modules/whiteboard/components/TopPanel/PreferencesMenu/WhiteboardHamburgerMenu.tsx